import { FC, useContext } from 'react'
import { Icon } from '../Generic'
import { observer } from 'mobx-react'
import { StoreContext } from '@store/Root.store'
import './DownloadDocumentButton.css'
import { cx } from '@/utils/cx'

interface DownloadDocumentButtonProps {
  documentUrl: string
  margin?: string
  onClick?: () => void
  alwaysDisplayText?: boolean
}

export const DownloadDocumentButton: FC<DownloadDocumentButtonProps> = observer(
  ({ documentUrl, margin, onClick, alwaysDisplayText }) => {
    const store = useContext(StoreContext)
    const { signDocumentPage: trans } = store.TranslationsState.translations

    if (!documentUrl) {
      return <></>
    }

    return (
      <a
        className={cx(
          'download-doc-button',
          margin === '0' && 'download-doc-button--margin-0',
          alwaysDisplayText && 'download-doc-button--always-display-text'
        )}
        tabIndex={0}
        href={documentUrl}
        target="_blank"
        rel="noopener noreferrer"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.currentTarget.click()
            onClick && onClick()
          }
        }}
        onClick={onClick}
      >
        <span>{trans.downloadButton}</span>
        <Icon color="currentColor" colorHover="currentColor" type="download" size="24px" />
      </a>
    )
  }
)
